import z from 'zod'

import { zh } from '@/libs/utils/zod'

/* ---------------------------------- ENUM ---------------------------------- */

/**
 * - Store: selling, receiving, and inventory
 * - Warehouse: inventory only
 * - Supplier: external supplier
 */
export const OutletType = z.enum(['store', 'warehouse', 'supplier'])
export const DeviceType = z.enum(['kitchen', 'cashier'])
export const DeviceStatus = z.enum(['active', 'inactive'])

export type OutletType = z.infer<typeof OutletType>
export type DeviceType = z.infer<typeof DeviceType>
export type DeviceStatus = z.infer<typeof DeviceStatus>

/* ------------------------------- BASE SCHEMA ------------------------------ */

export const OutletDto = z.object({
  name: z.string(),
  code: z.string(),
  desc: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  address: z.string().nullish(),
  type: OutletType,
  mokaId: z.string().nullable(),
  ...zh.metadata.shape,
})

export type OutletDto = z.infer<typeof OutletDto>

export const OutletRefDto = OutletDto.pick({
  id: true,
  name: true,
  code: true,
  type: true,
})

export type OutletRefDto = z.infer<typeof OutletRefDto>

export const DeviceDto = z.object({
  ...zh.metadata.shape,
  outletId: z.string(),
  name: z.string(),
  code: z.string(),
  desc: z.string(),
  type: DeviceType,
  status: DeviceStatus,
  claimCode: z.string().nullable(),
  claimedAt: z.string().nullable(),
  lastSyncAt: z.string(),
  meta: z
    .object({
      os: z.string(),
      osVersion: z.string(),
      appVersion: z.string(),
    })
    .nullable(),
})

export type DeviceDto = z.infer<typeof DeviceDto>
